export const emailsSeparatedCommas = (emails: string): boolean => {
  const emailsRegex = /^([\w+.%]+@[\w-.]+\.[A-Za-z]{2,8},?)+$/;
  return emailsRegex.test(emails);
};
